import "./ArchiveProductTemplate.module.css"
import AutoMotiGalvene from "@/reusable_sections/Header"
import ArchiveTitleSectionSection from "./sections/ArchiveTitleSectionSection"
import ShopContent from "./sections/ShopContent"
import Footer from "@/reusable_sections/Footer"

export default function ArchiveProductTemplatePage() {

  return (
    <div>
      <AutoMotiGalvene />
      <ArchiveTitleSectionSection />
      <ShopContent />
      <Footer />
    </div>
  )
}
